import Counter from 'components/counter';
import StatisticsCounterStyleWrapper from './Count.style';
import { useTranslation } from 'react-i18next';

const StatisticsCounter = () => {
  const { t } = useTranslation();

  //   보유자 6115
  // 투툐자 6115
  // 초기 $97.9M
  // 모금자본 $264M

  const data = [
    {
      title: t('statistics.holders'),
      value: '6115',
    },
    {
      title: t('statistics.voters'),
      value: '6115',
    },
    {
      title: t('statistics.raisedCapital'),
      value: '264',
    },
    {
      title: t('statistics.initialMarketCap'),
      value: '97.9',
    },
  ];

  return (
    <StatisticsCounterStyleWrapper className="tokenomics-counter-wrapper">
      <div className="row counter-row">
        {data?.map((stat, i) => (
          <div key={i} className="col-md-3 col-sm-6">
            <div className="counter-info">
              <h4 className="counter-number ">
                {i > 1 ? '$' : ''}
                <Counter
                  end={stat.value}
                  decimal="."
                  decimals={stat.value % 1 !== 0 ? '2' : '0'}
                  suffix={i > 1 ? 'M+' : ''}
                />
              </h4>
              <h5 className="counter-title">{stat.title}</h5>
            </div>
          </div>
        ))}
      </div>
    </StatisticsCounterStyleWrapper>
  );
};

export default StatisticsCounter;
